module.exports = __webpack_public_path__ + "static/img/tina_wang.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coaches/tina_wang.jpg
// module id = voBD
// module chunks = 0